import { render, staticRenderFns } from "./headdownload.vue?vue&type=template&id=6b1f454c&scoped=true&"
import script from "./headdownload.vue?vue&type=script&lang=js&"
export * from "./headdownload.vue?vue&type=script&lang=js&"
import style0 from "./headdownload.vue?vue&type=style&index=0&id=6b1f454c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1f454c",
  null
  
)

export default component.exports